import React from 'react';
import styled from 'styled-components';

interface EventBadgesProps {
  events: string | string[];
}

const BadgeContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

const EventBadge = styled.span`
  background-color: #4948ac;
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
`;

const NoEventsText = styled.span`
  color: #9399b2;
  font-style: italic;
  font-size: 14px;
`;

export const EventBadges: React.FC<EventBadgesProps> = ({ events }) => {
  // Convert to array if it's a string or handle empty cases
  let eventsArray: string[] = [];

  if (Array.isArray(events)) {
    eventsArray = events;
  } else if (events) {
    eventsArray = [events];
  }

  if (eventsArray.length === 0) {
    return <NoEventsText>No Events</NoEventsText>;
  }

  return (
    <BadgeContainer>
      {eventsArray.map(event => (
        <EventBadge key={event}>{event}</EventBadge>
      ))}
    </BadgeContainer>
  );
};
